import axios from 'axios';

import { publicAxiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const getClubPackageByClubId = (clubId) =>
  axios.get(
    `${getV2RootUrl()}/club-package/next/for-web?clubId=${clubId}`,
    publicAxiosHeaderV2()
  );
